// @flow

import { ACTIONS } from './constants';

const closeCalendarMessagingSummaryDrawer = () => (dispatch: Function) => {
    return dispatch({
        type: ACTIONS.CLOSE_SUMMARY_DRAWER
    });
};

export default closeCalendarMessagingSummaryDrawer;
